export default {
    data() {
        return {
            success: {
                name: false,
                address: false,
                country: false,
                vatNumber: false,
                email: false,
                primaryPhone: false
            },
            error: {
                name: "",
                address: "",
                country: "",
                vatNumber: "",
                email: "",
                primaryPhone: ""
            },
            errorMessages: {
                nameRequired: {
                    el: "Το όνομα του καταστήματος είναι υποχρεωτικό",
                    en: "Store Name is required",
                    it: "Il nome del negozio è obbligatorio"
                },
                nameLength: {
                    el: "Το όνομα του καταστήματος πρέπει να αποτελείται από τουλάχιστον 5 χαρακτήρες",
                    en: "Store Name must be at least 5 characters long",
                    it: "Il nome del negozio deve essere lungo almeno 5 caratteri"
                },
                countryRequired: {
                    el: "Απαιτείται Χώρα",
                    en: "Country is required",
                    it: "È richiesto il paese"
                },
                addressRequired: {
                    el: "Απαιτείται διεύθυνση",
                    en: "Address is required",
                    it: "L'indirizzo è richiesto"
                },
                addressIsPostal: {
                    el: "Παρακαλούμε επιλέξτε μια διεύθυνση που έχει ταχυδρομικό κώδικα",
                    en: "Please select an address that has a postal code",
                    it: "Selezionare un indirizzo con codice postale"
                },
                vatNumberRequired: {
                    el: "Απαιτείται αριθμός ΑΦΜ",
                    en: "Vat Number is required",
                    it: "È richiesto il numero di partita IVA"
                },
                vatNumberLength: {
                    el: "Ο Αριθμός ΑΦΜ πρέπει να έχει από 9 εώς χαρακτήρες",
                    en: "Vat Number must be from 9 to 12characters long",
                    it: "Il numero di partita IVA deve avere una lunghezza compresa tra 9 e 12 caratteri."
                },
                emailRequired: {
                    el: "Απαιτείται e-mail ",
                    en: "E-mail is required",
                    it: "E-mail è richiesto"
                },
                emailValid: {
                    el: "Το e-mail πρέπει να είναι έγκυρο",
                    en: "E-mail must be valid",
                    it: "L'e-mail deve essere valida"
                },
                primaryPhoneRequired: {
                    el: "Απαιτείται πρωτεύον τηλέφωνο",
                    en: "Primary Phone is required",
                    it: "Il telefono principale è obbligatorio"
                },
                primaryPhoneLength: {
                    el: "Το πρωτεύον τηλέφωνο πρέπει να αποτελείται από 10 χαρακτήρες",
                    en: "Primary Phone must be 10 characters long",
                    it: "Il telefono principale deve essere composto da 10 caratteri"
                }
            }
        };
    },

    computed: {
        valid() {
            return (
                this.success.name &&
                this.success.address &&
                this.success.country &&
                this.success.vatNumber &&
                this.success.email &&
                this.success.primaryPhone
            );
        }
    },

    methods: {
        validateName() {
            if (!this.storeDetails.name) {
                this.error.name = this.errorMessages.nameRequired[this.lang];
            } else if (this.storeDetails.name.length < 5) {
                this.error.name = this.errorMessages.nameLength[this.lang];
            } else {
                this.error.name = "";
            }
        },

        validateAddress() {
            if (!this.storeDetails.address) {
                this.error.address = this.errorMessages.addressRequired[
                    this.lang
                ];
            } else if (!this.isAddress) {
                this.error.address = this.errorMessages.addressIsPostal[
                    this.lang
                ];
            } else {
                this.error.address = "";
            }
        },
        validateCountry() {
            if (!this.storeDetails.country_id) {
                this.error.country = this.errorMessages.countryRequired[
                    this.lang
                ];
            } else {
                if (this.storeDetails.vat_number) {
                    this.validateVatNumber()
                }
                this.error.country = "";
            }
        },
        async validateVatNumber() {
            let isValid = false;
            this.error.vatNumber = "";
            if (!this.storeDetails.vat_number) {
                this.error.vatNumber = this.errorMessages.vatNumberRequired[
                    this.lang
                ];
                isValid = false;
            } else if (this.storeDetails.vat_number.length < 9 || this.storeDetails.vat_number.length > 12) {
                this.error.vatNumber = this.errorMessages.vatNumberLength[
                    this.lang
                ];
                isValid = false;
            } else if (this.storeDetails.vat_number?.length >= 9) {
                let res = await this.checkVatNumber({
                    afm: this.storeDetails.vat_number,
                    country_id: this.storeDetails.country_id
                });
                if (res.data?.status === 'success') {
                    this.error.vatNumber = "";
                    isValid = true;
                } else if (res.data?.error) {
                    this.error.vatNumber = res.data?.message || "";
                    isValid = false;
                }
            }
            return isValid;
        },

        validateEmail() {
            if (!this.storeDetails.email) {
                this.error.email = this.errorMessages.emailRequired[this.lang];
            } else if (!/.+@.+/.test(this.storeDetails.email)) {
                this.error.email = this.errorMessages.emailValid[this.lang];
            } else {
                this.error.email = "";
            }
        },

        validatePrimaryPhone() {
            if (!this.storeDetails.primary_phone) {
                this.error.primaryPhone = this.errorMessages.primaryPhoneRequired[
                    this.lang
                ];
            } else if (this.storeDetails.primary_phone.length !== 10) {
                this.error.primaryPhone = this.errorMessages.primaryPhoneLength[
                    this.lang
                ];
            } else {
                this.error.primaryPhone = "";
            }
        }
    },

    watch: {
        ["storeDetails.name"](val) {
            if (val) {
                this.success.name = val.length >= 5;
            } else {
                this.success.name = false;
            }
        },

        ["storeDetails.address"](val) {
            this.success.address = !!val && this.isAddress;
        },
        
        ["storeDetails.country_id"]: {
            immediate: true,
            handler(val) {
                this.success.country = !!val;
            }
        },
        ["storeDetails.vat_number"](val) {
            if (val) {
                this.success.vatNumber = val.length >= 9 && val.length <= 12;
            } else {
                this.success.vatNumber = false;
            }
        },

        ["storeDetails.email"](val) {
            this.success.email = /.+@.+/.test(val);
        },

        ["storeDetails.primary_phone"](val) {
            if (val) {
                this.success.primaryPhone = val.length === 10;
            } else {
                this.success.primaryPhone = false;
            }
        }
    }
};
